export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/accountability/resources/components.js